export default __webpack_public_path__ + "static/media/scr7.3df7bfad.png";